import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { ButtonT2 } from "Components/Common/Button/index";

const Footer = (props) => {
  const { 
    handleCreateRequestBtn ,
    isCreateRequestForm,
    handleUpdateRequestBtn,
    handleOnClickForSaveAndCloseBtn,
    handleOnClickForDiscardBtn
  } = props;

  return (
    <Fragment>
      <FooterWrapper>
       <ButtonT2 onClick={handleOnClickForDiscardBtn}>Discard</ButtonT2>
       <ButtonT2 onClick={handleOnClickForSaveAndCloseBtn}>Save and Close</ButtonT2>
       {isCreateRequestForm && <ButtonT2 onClick={handleCreateRequestBtn}>Create Request</ButtonT2>}
       {!isCreateRequestForm && <ButtonT2 onClick={handleUpdateRequestBtn}>Update Request</ButtonT2>}
      </FooterWrapper>
    </Fragment>
  );
};

export default Footer;

export const FooterWrapper = styled.div`
  position: fixed;
  background: #fff;
  box-shadow: 0px -4px 9px 0px rgba(98, 127, 233, 0.24);
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 15px 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
`;
